import type { DevelopersCopy } from "../types";

export const DEVELOPERS_PT_BR: DevelopersCopy = {
  home: "Início",
  breadcrumb: "Para desenvolvedores",
  breadcrumbLabel: "Você está em",
  sectionNavLabel: "Nesta página",
  sectionNav: [
    { label: "Bootgly", href: "#bootgly" },
    { label: "Dataruni", href: "#dataruni" },
    { label: "Codecious Build", href: "#build" },
  ],
  hero: {
    heading: "Para desenvolvedores",
    lead: "Projetos de código aberto e ferramentas para quem constrói software: um framework PHP, uma biblioteca para apps React e uma plataforma em preparação.",
  },
  bootgly: {
    heading: "Bootgly",
    tagline: "The native, zero-dependency PHP framework.",
    lead: "Framework PHP nativo e sem dependências, com um único núcleo assíncrono para Web e CLI e um servidor HTTP escrito em PHP puro.",
    facts: [
      "Código aberto (licença MIT)",
      "Versão estável: linha 1.x",
      "PHP 8.4 ou superior",
      "Zero dependências em tempo de execução",
    ],
    benchmark: {
      text: "1.084.550 requisições por segundo no teste /plaintext do TechEmpower, em medição do próprio projeto (25/07/2026).",
      source: {
        label: "Ver a comparação",
        href: "https://docs.bootgly.com/manual/WPI/HTTP/HTTP_Server_CLI/vs/",
      },
    },
    installLabel: "Instalação (Linux ou WSL2)",
    installCommand: "curl -fsSL https://bootgly.com/install | bash",
    copyLabel: "Copiar comando",
    copiedLabel: "Comando copiado",
    copyFailedLabel:
      "Não foi possível copiar. O comando foi selecionado: use Ctrl+C ou Cmd+C.",
    links: {
      site: "Site do Bootgly",
      docs: "Documentação",
      github: "GitHub",
      packagist: "Packagist",
    },
    externalNote:
      "O Bootgly tem site e documentação próprios. Os links abrem em uma nova aba.",
  },
  dataruni: {
    heading: "Dataruni",
    badge: "Experimental",
    lead: "Biblioteca para apps React que junta o armazenamento local do navegador (IndexedDB) ao estado do React, para os dados do app continuarem salvos entre visitas.",
    installLabel: "Instalação",
    installCommand: "npm install @codecious/dataruni",
    links: { npm: "npm", github: "GitHub" },
  },
  build: {
    heading: "Codecious Build",
    badge: "Em breve",
    lead: "Plataforma com IA para planejar, desenvolver, testar e publicar projetos de software. Está em fase de planejamento.",
    waitlistTitle: "Quer saber quando abrir?",
    waitlistText:
      "Entre na lista de espera e avisamos por e-mail quando o Codecious Build estiver disponível.",
  },
};
